document.getElementById("myElement").addEventListener("mouseenter", () => {
    document.getElementById("myElement").classList.add("hoverEffect");
});

document.getElementById("myElement").addEventListener("mouseleave", () => {
    document.getElementById("myElement").classList.remove("hoverEffect");
});